import Api from './api';
import { getUser, getInitialNavigationPage, restoreInitialUser } from './auth';

/**
 * Ends an admin impersonation session ("Go back to Admin").
 *
 * Records the logout server-side, then restores the admin's own
 * user/token and navigates back to where the admin came from.
 *
 * The logout route is admin-only, so we restore the admin token first
 * and let the request helper send it. Failures are swallowed so the
 * admin is never trapped in the impersonated session.
 */
export const goBackToAdmin = async (): Promise<void> => {
  const navLink = getInitialNavigationPage() ?? '/admin/customers';
  const impersonatedUserId = getUser()?.id;

  // Restore the admin user/token first so the logout call is authorized
  // with the admin's own token rather than the impersonation token.
  restoreInitialUser();

  if (impersonatedUserId) {
    try {
      await Api.users.logoutFromImpersonation(impersonatedUserId);
    } catch (e) {
      // Non-blocking: navigate back to admin regardless.
    }
  }

  window.location.href = navLink;
};

export default goBackToAdmin;
